/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import {
  AbstractFormComponent,
  BuilderNavigationService,
  BuilderUserContext,
  CommonActions,
  FormActionPipelines,
  FormFlowState,
  TaxRate,
  TaxRateFinderDialogConfig,
  taxRateFinderDialogRoute,
} from '@gh/builder-shared';
import { AelEvents } from '@gh/builder-shared-data';
import { ActionFlow, getRouteInitData, getSingleNewSelectedEntity, IS_REGION_AU_OR_NZ } from '@gh/common-shared';
import { TranslationService } from '@gh/core-mls';
import { DialogService, yesAnswer, yesNoConfirmation } from '@gh/core-ui';
import { filter$, map$ } from '@gh/rx/operators';

import { SystemVarsLedger } from '../../resources/model/system-vars-ledger.model';
import { SystemVarsLedgerTabBusinessService } from '../../resources/system-vars-ledger-tab-business.service';
import { SystemVarsLedgerTabFormState } from './system-vars-ledger-form.service';

@Component({
  selector: 'gh-system-vars-ledger-tab',
  template: require('./system-vars-ledger-tab.component.html'),
  providers: [
    SystemVarsLedgerTabFormState,
  ],
})
export class SystemVarsLedgerTabComponent extends AbstractFormComponent<SystemVarsLedger> implements OnInit {
  isRegionAuNz = IS_REGION_AU_OR_NZ;
  private ledgerSystemVariables: SystemVarsLedger;

  constructor(public form: SystemVarsLedgerTabFormState,
              private route: ActivatedRoute,
              private translationService: TranslationService,
              private systemVarsBusiness: SystemVarsLedgerTabBusinessService,
              private navigationService: BuilderNavigationService,
              private dialogService: DialogService,
              private userContext: BuilderUserContext,
              private pipelines: FormActionPipelines,
              private actions: CommonActions) {
    super();
  }

  ngOnInit(): void {
    this.ledgerSystemVariables = getRouteInitData(this.route)['ledgerSystemVariables'];
    this.form.build(this.ledgerSystemVariables);
    this.onGstAppliesChange();
  }

  get completeFlow(): ActionFlow<FormFlowState<SystemVarsLedger>> {
    return this.pipelines.complete({
      execute: this.actions.execute(({ value }: FormFlowState<SystemVarsLedger>) =>
        this.systemVarsBusiness.update(value)),
      finish: ({ value }: FormFlowState<SystemVarsLedger>) => {
        this.ledgerSystemVariables = value;
        this.form.build(value);
      },
    });
  }

  onReset(): void {
    this.dialogService
      .confirmation(yesNoConfirmation('msg_reset')).pipe(
      filter$(yesAnswer))
      .subscribe(() => this.form.build(this.ledgerSystemVariables));
  }

  goToAel(): void {
    this.navigationService.goToAel({
      entityId: this.userContext.office && this.userContext.office.id,
      entityType: 'OFFICE',
      eventTypeIds: [AelEvents.Office.EditedLedger],
      label: 'lbl_general_ledger',
    });
  }

  onGstAppliesChange(): void {
    this.form.gstAppliesChange();
  }
}
